import isCopySupported from "./is-copy-supported";
import { marked } from "marked";
import removeMd from "remove-markdown";
import Notification from "../components/Notification";

interface UseCopyClipboardParams {
  showNotification?: boolean;
  copySuccessMessage?: string;
  copyFailedMessage?: string;
}

interface UseCopyClipboardReturn {
  copyToClipboard: (content: string) => Promise<void>;
}

const useCopyClipboard = ({
  showNotification,
  copySuccessMessage,
  copyFailedMessage
}: UseCopyClipboardParams): UseCopyClipboardReturn => {
  const copyToClipboard = async (content: string): Promise<void> => {
    try {
      if (isCopySupported && content) {
        const { ClipboardItem } = window;
        const htmlBlob = new Blob([marked(content) as string], {
          type: "text/html"
        });
        const textBlob = new Blob([removeMd(content)], { type: "text/plain" });

        const data = [
          new ClipboardItem({
            "text/html": htmlBlob,
            "text/plain": textBlob
          })
        ];

        await navigator.clipboard.write(data);
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(content);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = removeMd(content);
        document.body.appendChild(textArea);
        textArea.select();
        document.body.removeChild(textArea);
      }

      if (showNotification && copySuccessMessage) {
        Notification.success(copySuccessMessage);
      }
    } catch (err) {
      console.error("Failed to copy:", err);

      if (showNotification && copyFailedMessage) {
        Notification.error(copyFailedMessage);
      }
    }
  };

  return { copyToClipboard };
};

export default useCopyClipboard;
